import { render, staticRenderFns } from "./Re-arrange.vue.js?vue&type=template&id=504cf564!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Re-arrange.vue?vue&type=template&id=504cf564"
import script from "./Re-arrange.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Re-arrange.vue?vue&type=script&lang=js"
export * from "./Re-arrange.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Re-arrange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports